/* eslint-disable @next/next/no-img-element */
import React, { useContext, useState } from "react";
import {
  CarouselWithState,
  ImageSlide,
} from "components/componentLibrary/carousel";
import MobileContext from "context/MobileContext";
import cn from "classnames";
import { ImageAttachedToKind } from "types/globalTypes";
import Lightbox from "components/Lightbox";
import styles from "./style.module.scss";

type Props = {
  images: { id: string; url: string }[];
  lightBoxImages?: { id: string; url: string }[];
  imageSlideOverride?: string;
  showMapPin?: boolean;
  address: string;
  imageUpload?: {
    attachedToKind: ImageAttachedToKind;
    attachedToId: string;
    onImageUploadComplete: Function;
  };
  deleteCampaignListingImages?: {
    campaignListingUUID: string;
    campaignImages: { id: string; uuid: string }[];
  };
};

const MapCarousel = ({
  images,
  imageSlideOverride = "",
  lightBoxImages,
  address,
  showMapPin = true,
  imageUpload,
  deleteCampaignListingImages,
}: Props) => {
  const isMobileView = useContext(MobileContext); // use this over isTouch() or css checking. It can determine mobile user during ssr.
  const [selectedImageId, setSelectedImageId] = useState("");
  const eagerLoadingThreshold = isMobileView ? 1 : 4; // index is from 0 so this is first 2 on mobile or 5 on desktop

  return (
    <>
      {selectedImageId && (
        <Lightbox
          images={lightBoxImages || images}
          title={address}
          onClose={() => setSelectedImageId("")}
          initial={
            images.findIndex((image) => image?.id === selectedImageId) || 0
          }
          imageUpload={imageUpload}
          deleteCampaignListingImages={deleteCampaignListingImages}
        />
      )}
      <div className={styles.carousel}>
        {/* Add the ability to click a carousel image and open said image in the lightbox. */}
        <CarouselWithState>
          {images.map(
            (image, i) =>
              image && (
                <ImageSlide
                  data-jest={`image-slide-${i}`}
                  key={image.url}
                  src={image.url}
                  className={cn(styles.ImageSlide, imageSlideOverride)}
                  loading={i < eagerLoadingThreshold ? "eager" : "lazy"}
                  onClick={() => setSelectedImageId(image.id)}
                />
              )
          )}
        </CarouselWithState>
        {showMapPin && (
          <div className={styles.mapPin}>
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
            <img
              src="/nextpublic/map-pin.svg"
              alt="map-pin"
              onClick={() => setSelectedImageId(images[images.length - 1].id)}
              onKeyPress={(e) => {
                if (e.key === "Enter")
                  setSelectedImageId(images[images.length - 1].id);
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default MapCarousel;
